import { render, staticRenderFns } from "./Catalogue.vue?vue&type=template&id=31bfd7e4"
import script from "./Catalogue.vue?vue&type=script&lang=ts"
export * from "./Catalogue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports